//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {};
  },
  computed: {
    getFilters: function getFilters() {
      return typeof this.filters !== 'undefined' ? this.filters.map(function (filter) {
        return filter.name;
      }).join(' + ') : '';
    }
  },
  props: ['link', 'title', 'image', 'filters']
};